import { defineMessages } from 'react-intl-next';

import type { SearchIssueStatusCategory } from '@atlassian/search-client';

export const i18n: Record<SearchIssueStatusCategory, import('react-intl-next').MessageDescriptor> =
	defineMessages<SearchIssueStatusCategory>({
		OPEN: {
			id: 'search-page.filter.status.open',
			defaultMessage: 'Open',
			description: 'Open status for a Jira issue',
		},
		DONE: {
			id: 'search-page.filter.status.done',
			defaultMessage: 'Done',
			description: 'Done status for a Jira issue',
		},
		INDETERMINATE: {
			id: 'search-page.filter.status.indeterminate',
			defaultMessage: 'In Progress (Open)',
			description: 'In Progress status for a Jira issue',
		},
		UNDEFINED: {
			id: 'search-page.filter.status.undefined',
			defaultMessage: 'Other',
			description: 'No Category status for a Jira issue',
		},
		NEW: {
			id: 'search-page.filter.status.new',
			defaultMessage: 'To Do (Open)',
			description: 'To Do status for a Jira issue',
		},
	});
